<template>
  <div class="progress">
    <div class="progress__scale" :style="{ width: `${percent}%` }">
      <div class="progress__percent">
        {{ percent }}%
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseProgress',
  props: {
    percent: {
      type: Number,
      default: 65,
    },
  },
};
</script>

<style lang="stylus">
.progress
  display block
  width 100%
  height 6px
  background-color #DEE6FF
  border-radius @height
  &__scale
    position relative
    display block
    width auto
    height inherit
    border-radius inherit
    color $c_bright
    background-color currentColor
    transition width 1400ms cubic-bezier(0.76, 0, 0.24, 1)
    //cubic-bezier(0.45, 0, 0.55, 1)//cubic-bezier(0.85, 0, 0.15, 1)//cubic-bezier(0, 0.55, 0.45, 1)
  &__percent
    abs bottom 100% right
    font-size 0.7em//12px
    padding 0.25em 0
</style>
